import { InternalError } from '../components/InternalError';
import { SuccessEmail } from '../components/SuccessEmail';
import styles from '../styles/contato.module.css';
import { HeaderContactForm } from '../components/ContactForm/header';
import { BackButton } from '../components/Button/back-button';
import { Input } from '../components/Input';
import { Textarea } from '../components/Textarea';
import { Button } from '../components/Button';

import { useForm } from '../hooks/useForm';
import { Section } from '../components/Section';
import ReCAPTCHA from 'react-google-recaptcha';

export default function Contato() {
  const {
    reset,
    message,
    formRef,
    formError,
    formatInput,
    isSubmitting,
    reCAPTCHARef,
    handleSubmit,
  } = useForm();

  const reCAPTCHAKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';
  const projectCitation = `@misc{AlertaRolante,
  title = {{Alerta Rolante: plataforma de informações hidrometeorológicas e alertas para a Bacia Hidrográfica do Rio Rolante}},
  author = {Melo, Rayane and Hillebrand, Fernando and Schardong, Frederico and Muller, Fernanda},
  year = {2025},
  howpublished = {https://alerta.rolante.ifrs.edu.br}
}`;

  return (
    <Section>
      <div className={`${styles.contactWrapper} container col-md-8 col-lg-6`}>
        <form onSubmit={handleSubmit} ref={formRef} className={styles.formWrapper}>
          {message === 'success' ? (
            <SuccessEmail />
          ) : message === 'error' ? (
            <InternalError />
          ) : (
            <>
              <HeaderContactForm />
              <Input
                label="Nome *"
                id="nome"
                name="nome"
                type="text"
                required
              />
              <Input
                label="E-mail"
                id="email"
                name="email"
                type="email"
                error={formError}
              />
              <Input
                label="Telefone"
                id="telefone"
                name="telefone"
                type="text"
                onChange={(e) => formatInput(e, 'telefone')}
                error={formError}
              />
              <Textarea
                label="Mensagem *"
                id="mensagem"
                name="mensagem"
                required
              />
              <div className="d-grid mt-4">
                <Button type="submit" isLoading={isSubmitting} text="Enviar" />
              </div>
            </>
          )}

          {message && <BackButton onClick={() => reset()} />}
          <ReCAPTCHA
            ref={reCAPTCHARef}
            sitekey={reCAPTCHAKey}
            size="invisible"
            badge="bottomright"
          />
        </form>

        <div className={styles.citationWrapper}>
          <h3 className={styles.citationTitle}>Como citar os colaboradores</h3>
          <pre className={styles.citationBlock}>{projectCitation}</pre>
        </div>
      </div>
    </Section>
  );
}
